import React ,{useEffect} from 'react'
import './index.css';
import { NavLink } from "react-router-dom";
import Aos from "aos"
import "aos/dist/aos.css"


const About = () => {
    useEffect(() => {
        Aos.init({duration:1200});
    },[])

    return (
        <div>
            <body>
                <section className='about'>
                    <div className='container'>
                        <h2 className='lg-heading text-black about-heading'>ABOUT US</h2>
                        <p className='text-grey'>Founded in May, 2000, by a team of young and enthusiastic professionals, Gravity Gym feature progressive programs with world class fitness equipment, trainers and nutrition counselors to help you your fitness further.</p>
                        <div className='about-wrapper'>
                            <div className='left'>
                                <ul>
                                    <li>WeightLifting</li>
                                    <li>Specific Muscle</li>
                                    <li>Cardio Exercise</li>
                                    <li>Reduce Mental Stress</li>
                                </ul>
                            </div>
                            <div className='right'>
                                <ul>
                                    <li>Cardio Area</li>
                                    <li>Cycle Studio</li>
                                    <li>Personal Training</li>
                                    <li>Balance your body</li>
                                </ul>
                            </div>
                        </div>
                        <div className='counts'>
                            <div className='count-item count-item1'>
                                <span className='md-heading text-green bold'>2500+</span>
                                <p className='bold text-grey'>Members</p>
                            </div>
                            <div className='count-item count-item2'>
                                <span className='md-heading text-green bold'>200+</span>
                                <p className='bold text-grey'>Guide</p>
                            </div>
                            <div className='count-item count-item3'>
                                <span className='md-heading text-green bold'>20+</span>
                                <p className='bold text-grey'>Trainers</p>
                            </div>
                            <div className='count-item count-item4'>
                                <span className='md-heading text-green bold'>20+</span>
                                <p className='bold text-grey'>Support</p>
                            </div>
                        </div>
                        <div data-aos="fade-down" className='cta-banner'>
                            <div className='cta-banner-left cta'>
                                <p className='cta-line bold text-dark'>What are you waiting for, reach us right now.</p>
                            </div>
                            <div className='cta-banner-right cta'>
                                <NavLink to="./contact" className='btn-cta bold btn-primary1'>Contact Us</NavLink>
                            </div>
                        </div>
                    </div>
                </section>
            </body>
        </div>
    )
}

export default About
